(function () {
	'use strict';
	// if client.js return data from installed AV

	function checkClient() {
		if (typeof avastGlobals.client !== 'undefined') {
			window.location.href = 'lp-safe-emailing-win-browser?brcmpgid=6306';
		}
	}

	window.addEventListener('clientLoaded', function () {
		checkClient();
	})

	checkClient();
})();
